import { BooleanInput, Create, ImageField, ImageInput, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { RichText } from '../sessions/fields';

const initialValues = {
  firstname: '',
  lastname: '',
  id: undefined,
  cv: '',
  countryId: undefined,
  isRockStar: false,
};

export const SpeakerCreate = () => (
  <Create title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="firstname" />
      <TextInput source="lastname" />
      <ReferenceInput source="countryId" reference="countries">
        <SelectInput optionText="title" />
      </ReferenceInput>
      <RichText source="cv" />
      <ImageInput source="avatar" label="avatar" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <BooleanInput source="isRockStar" />
    </SimpleForm>
  </Create>
);
